import { Box } from '@mui/material';
import React from 'react';

export const TermsAndCondition: React.FC = () => {
  return (
    <Box
      className="p-6 max-w-3xl mx-auto box-container-layout"
      sx={{ color: '#fff' }}
    >
      <h1 className="text-2xl font-bold mb-4">Terms and Conditions</h1>
      <p className="mb-2">
        Welcome to our application. By accessing or using our service, you agree
        to be bound by these Terms and Conditions.
      </p>
      <h2 className="text-xl font-semibold mt-4 mb-2">1. Use of Service</h2>
      <p className="mb-2">
        You agree to use the service only for lawful purposes and in accordance
        with these Terms.
      </p>
      <h2 className="text-xl font-semibold mt-4 mb-2">
        2. Intellectual Property
      </h2>
      <p className="mb-2">
        All content, features, and functionality are owned by us and are
        protected by intellectual property laws.
      </p>
      <h2 className="text-xl font-semibold mt-4 mb-2">3. Termination</h2>
      <p className="mb-2">
        We may terminate or suspend access immediately, without prior notice,
        for any breach of these Terms.
      </p>
      <h2 className="text-xl font-semibold mt-4 mb-2">4. Contact Us</h2>
      <p>If you have any questions about these Terms, please contact us.</p>
    </Box>
  );
};
